import { atom } from "recoil";

export const printCodesAtom = atom({
  key: "printCodes",
  default: [],
});
